import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TrackTrafficService {

  //encode the email properly because @ in URL can sometimes create issues.
   private ownerEmail = encodeURIComponent('anaangproperty@gmail.com');
    // private ownerEmail = encodeURIComponent('rohitsharma2605555@gmail.com');

   // REST API URL
    private url = `https://rsbusinesstech-backend.onrender.com/common/trackTraffic/${this.ownerEmail}`;
  //  private url = `http://127.0.0.1:8080/common/trackTraffic/${this.ownerEmail}`;
  
    //Dependency Injection of HttpClient(Constrcutor DI).
    constructor(private httpClient: HttpClient) { }
  
    //calling Rest-API to send email.
    trackTraffic(){
      return this.httpClient.get<string>(this.url);
    }
}
